// Utah Motorworks site: tap-to-pick chips and the Text/Call toggle fill hidden form fields.
document.querySelectorAll('.chips').forEach(function (g) {
  var multi = g.getAttribute('data-multi') === 'true', out = g.querySelector('input');
  g.addEventListener('click', function (e) {
    var c = e.target.closest('.chip'); if (!c) return;
    if (multi) c.classList.toggle('on');
    else {
      var was = c.classList.contains('on');
      g.querySelectorAll('.chip').forEach(function (x) { x.classList.remove('on'); });
      if (!was) c.classList.add('on');
    }
    if (out) out.value = Array.prototype.map.call(g.querySelectorAll('.chip.on'), function (x) { return x.textContent; }).join(', ');
  });
});
document.querySelectorAll('.seg').forEach(function (g) {
  var out = g.querySelector('input');
  g.addEventListener('click', function (e) {
    var c = e.target.closest('span'); if (!c) return;
    g.querySelectorAll('span').forEach(function (x) { x.classList.remove('on'); });
    c.classList.add('on');
    if (out) out.value = c.textContent;
  });
});
// Pick-one cards (Service page): fill the hidden field, and show "What we check" only for a checkup.
document.querySelectorAll('.pick').forEach(function (g) {
  var out = g.querySelector('input'), form = g.closest('form');
  g.addEventListener('click', function (e) {
    var c = e.target.closest('.pk'); if (!c) return;
    g.querySelectorAll('.pk').forEach(function (x) { x.classList.remove('on'); });
    c.classList.add('on');
    if (out) out.value = c.getAttribute('data-v');
    if (form) form.querySelectorAll('[data-for]').forEach(function (x) { x.hidden = x.getAttribute('data-for') !== c.getAttribute('data-v'); });
  });
});
document.querySelectorAll('.thanks').forEach(function (t) {
  t.addEventListener('click', function (e) { if (e.target === t) t.classList.remove('show'); });
});
document.querySelectorAll('.igwrap').forEach(function (w) {
  var row = w.querySelector('.igrow');
  w.querySelectorAll('.arr').forEach(function (a) {
    a.addEventListener('click', function () {
      row.scrollBy({ left: (a.classList.contains('l') ? -1 : 1) * row.clientWidth * 0.75, behavior: 'smooth' });
    });
  });
});
// Each inquiry also goes to the shop app, where it lands in the Estimate column. Shopify still emails it as a backup.
document.querySelectorAll('form#umw-lead').forEach(function (f) {
  f.addEventListener('submit', function () {
    var url = document.body.getAttribute('data-leads');
    if (!url) return;
    var data = {};
    new FormData(f).forEach(function (v, k) {
      if (typeof v === 'string' && k.indexOf('contact[') === 0) data[k] = v;
    });
    var body = JSON.stringify(data);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  });
});

// Part page: tap a thumbnail to show it big.
document.querySelectorAll('.thumbs button').forEach(function (b) {
  b.addEventListener('click', function () { var g = document.getElementById('umw-gal'); if (g) g.src = b.getAttribute('data-src'); });
});

// Shop and search pages: reload sorted, back on page 1. Price sorts leave out $0 ("Hide price") parts.
window.umwSort = function (value) {
  var u = new URL(location.href);
  u.searchParams.set('sort_by', value);
  u.searchParams.delete('page');
  if (value.indexOf('price') === 0) u.searchParams.set('filter.v.price.gte', '0.01');
  else u.searchParams.delete('filter.v.price.gte');
  location.href = u.toString();
};

// VIN lookup page: cleans the VIN as it's typed, looks it up at 17 characters, and shows the machine and recalls.
(function () {
  var form = document.getElementById('umw-vin');
  if (!form) return;
  var box = form.querySelector('input'), msg = document.getElementById('umw-vin-msg'), out = document.getElementById('umw-vin-out');
  var api = document.body.getAttribute('data-vin'), last = '';
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
  function clean(v) {
    v = v.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (v.length === 18 && v.charAt(0) === 'I') v = v.slice(1);
    return v.replace(/I/g, '1').replace(/[OQ]/g, '0');
  }
  function say(text, bad) { msg.textContent = text; msg.className = 'vinmsg' + (bad ? ' bad' : ''); }
  // The maker's own lookup (Polaris so far) answers browsers, not servers, so it's asked from here. NHTSA always shows too.
  function plain(t) { return String(t || '').replace(/<[^>]*>/g, '').replace(/&(reg|trade|copy|#174|#8482|#169);/gi, '').replace(/&amp;/gi, '&').replace(/&nbsp;/gi, ' ').replace(/[®™©]/g, '').replace(/\s+/g, ' ').trim(); }
  function tc(s) { return plain(s).replace(/^polaris\s+/i, '').toLowerCase().replace(/(^|[\s-])([a-z])/g, function (_, a, b) { return a + b.toUpperCase(); }).replace(/\b(Rzr|Xp|Eps|Rs1|Ho|Le|Ps|Rgr|Sxs|Atv|Orv)\b/g, function (w) { return w.toUpperCase(); }); }
  function isPolaris(vin) { return /^(4XA|3NS|4XB)/.test(vin); }
  function askMaker(vin) {
    if (!isPolaris(vin)) return Promise.resolve(null);
    var ctl = window.AbortController ? new AbortController() : null;
    if (ctl) setTimeout(function () { ctl.abort(); }, 8000);
    return fetch('https://www.polaris.com/en-us/off-road/owner-resources/vin-search/getvindetails/?vinNumber=' + vin + '&productLineCode=ORV&culture=en-us', ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (o) {
        if (!o) return null;
        // Either can carry the full name with color; the longer one does.
        var two = [tc(o.displayName), tc(o.vehicleDescription)].sort(function (a, b) { return b.length - a.length; });
        var name = two[0], other = two[1];
        if (!name) return null;
        var img = o.wholegoodMainImage || '';
        var fields = [['Model name', name], ['Model year', o.modelYear ? String(o.modelYear) : ''], ['Also called', other !== name ? other : ''], ['Product line', o.productLineCode === 'ORV' ? 'Off-road (ORV)' : o.productLineCode || '']];
        return { year: o.modelYear, name: name, image: img && img.indexOf('http') !== 0 ? 'https://www.polaris.com' + img : img, fields: fields };
      })
      .catch(function () { return null; });
  }
  // One source's bar: green with the machine when it found it, red "No results found" when it didn't. Opens to all it said.
  function source(vin, name, found, missing, image, fields, link, linkText, open) {
    var det = el('details', 'vsrc ' + (found ? 'hit' : 'miss'));
    if (open) det.open = true;
    var sum = el('summary');
    sum.appendChild(el('span', 'vsrcname', name));
    var st = el('span', 'vsrcst', found || 'No results found');
    if (!found) st.appendChild(el('small', '', missing));
    sum.appendChild(st);
    det.appendChild(sum);
    if (image) { var im = el('img', 'vinphoto'); im.src = image; im.alt = ''; det.appendChild(im); }
    var rows = fields.filter(function (x) { return x[1]; });
    if (rows.length) {
      var dl = el('dl', 'vinspec');
      rows.forEach(function (x) { dl.appendChild(el('dt', '', x[0])); dl.appendChild(el('dd', '', x[1])); });
      det.appendChild(dl);
    }
    var a = el('a', 'btn ghost2 full', linkText + ' ›'); a.href = link; a.target = '_blank'; a.rel = 'noopener';
    var note = el('p', 'vinp', 'Tapping copies your VIN so you can paste it there.');
    a.addEventListener('click', function () { if (navigator.clipboard) navigator.clipboard.writeText(vin).then(function () { note.textContent = 'VIN copied. Paste it there.'; }, function () {}); });
    det.appendChild(a);
    det.appendChild(note);
    return det;
  }
  function show(r, m, asked) {
    out.innerHTML = '';
    var d = r.decoded || {};
    var nhtsaName = [d.year, d.make, d.model, d.trim].filter(Boolean).join(' ');
    var card = el('div', 'vincard');
    card.appendChild(el('h2', '', m ? [m.year || d.year, d.make, m.name].filter(Boolean).join(' ') : nhtsaName || 'Unknown machine'));
    card.appendChild(el('div', 'vinsub', r.vin));
    card.appendChild(el('h3', 'vinh', 'Sources'));
    if (asked) card.appendChild(source(r.vin, 'Polaris', m ? [m.year || d.year, 'Polaris', m.name].filter(Boolean).join(' ') : '', "Polaris didn't answer. Open to search on their site.", m && m.image, m ? m.fields : [], 'https://www.polaris.com/en-us/off-road/owner-resources/vin-search/', 'Search this VIN on polaris.com', !!m));
    var nf = [['Year', d.year ? String(d.year) : ''], ['Make', d.make], ['Model', d.model], ['Series', (d.trim || '').replace(/\s*Turbo$/, '')]].concat((d.specs || []).map(function (x) { return [x.label, x.value]; }));
    card.appendChild(source(r.vin, 'NHTSA', d.full ? nhtsaName : '', "NHTSA didn't name the model. Year and maker are from the VIN.", '', nf, 'https://vpic.nhtsa.dot.gov/decoder/', 'Decode this VIN on nhtsa.gov', !m));
    if (d.model) {
      if (!r.recallsChecked) card.appendChild(el('p', 'vinp', "Couldn't reach the recall list right now. Try again later."));
      else {
        card.appendChild(el('h3', 'vinh', r.recalls.length ? r.recalls.length + ' recall' + (r.recalls.length === 1 ? '' : 's') + ' listed for this model' : 'No recalls listed for this model'));
        r.recalls.forEach(function (x) {
          var a = el('a', 'vinrc'); a.href = x.url; a.target = '_blank'; a.rel = 'noopener';
          a.appendChild(el('b', '', x.title.replace(/\s*\(Recall Alert\)\s*$/, '')));
          if (x.hazard) a.appendChild(el('span', '', x.hazard));
          a.appendChild(el('small', '', x.date.slice(0, 7) + ' · cpsc.gov'));
          card.appendChild(a);
        });
      }
    }
    if (r.recallUrl) { var c = el('a', 'btn ghost2 full', 'Check your VIN with ' + d.make + ' ›'); c.href = r.recallUrl; c.target = '_blank'; c.rel = 'noopener'; card.appendChild(c); }
    var s = el('a', 'btn full', 'Get setup advice for this machine'); s.href = '/pages/start';
    s.addEventListener('click', function (e) {
      var pick = document.getElementById('umw-pick');
      if (!pick) return;
      e.preventDefault();
      var y = (m && m.year) || d.year || '', model = m ? m.name : [d.model, d.trim].filter(Boolean).join(' ');
      var q = new URLSearchParams({ year: String(y), make: d.make || '', model: model, vin: r.vin }).toString();
      pick.querySelectorAll('.vpk-t').forEach(function (a) { a.href = '/pages/' + a.getAttribute('data-page') + '?' + q; });
      document.getElementById('umw-pick-for').textContent = [y, d.make, model].filter(Boolean).join(' ') + ". We'll fill it in for you.";
      pick.hidden = false;
    });
    card.appendChild(s);
    out.appendChild(card);
    out.hidden = false;
  }
  function look(vin) {
    if (!api || vin === last) return;
    last = vin;
    say('Looking it up…');
    Promise.all([fetch(api + '?vin=' + encodeURIComponent(vin)).then(function (res) {
      if (res.status === 429) throw new Error('Too many lookups. Try again in a bit.');
      if (!res.ok) throw new Error("Couldn't look that up right now. Try again.");
      return res.json();
    }), askMaker(vin)]).then(function (both) {
      var r = both[0];
      if (vin !== last) return;
      if (r.problem) return say(r.problem, true);
      say(vin);
      show(r, both[1], isPolaris(vin));
    }).catch(function (e) { if (vin === last) { last = ''; say(e.message, true); } });
  }
  function check(go) {
    var v = clean(box.value);
    if (box.value !== v) box.value = v;
    if (!v) return say('Works for Polaris, Can-Am, Honda, Yamaha, Kawasaki, CFMoto and more.');
    if (v.length !== 17) { out.hidden = true; last = ''; return say(v.length + ' of 17' + (v.length < 17 ? '. ' + (17 - v.length) + ' missing.' : '. A VIN has 17.'), go); }
    look(v);
  }
  box.addEventListener('input', function () { check(false); });
  form.addEventListener('submit', function (e) { e.preventDefault(); check(true); });
  var q = new URLSearchParams(location.search).get('vin');
  if (q) { box.value = q; check(true); }
})();

// Setup picker on the VIN page: closes on the X, a tap outside, or Escape.
(function () {
  var pick = document.getElementById('umw-pick');
  if (!pick) return;
  function close() { pick.hidden = true; }
  pick.querySelector('.vpk-x').addEventListener('click', close);
  pick.addEventListener('click', function (e) { if (e.target === pick) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// Forms opened from the VIN lookup (?year=&make=&model=&vin=): the machine is filled in and the VIN rides along.
(function () {
  var q = new URLSearchParams(location.search), vin = q.get('vin');
  if (!vin) return;
  document.querySelectorAll('form#umw-lead').forEach(function (f) {
    ['Year', 'Make', 'Model'].forEach(function (k) {
      var v = q.get(k.toLowerCase()), box = f.querySelector('[name="contact[' + k + ']"]');
      if (v && box && !box.value) box.value = v;
    });
    var h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[VIN]'; h.value = vin.slice(0, 24); f.appendChild(h);
    var note = document.createElement('p'); note.className = 'vinfrom';
    note.textContent = 'From your VIN lookup: ' + [q.get('year'), q.get('make'), q.get('model')].filter(Boolean).join(' ') + ' · ' + vin.slice(0, 24);
    var at = f.querySelector('.ymm'); if (at) at.parentNode.insertBefore(note, at);
  });
})();
